<template>  
  <div>
  <q-card inline style="width: 300px">
  <q-card-media>
    <img src="@/assets/Insafety.png">
  </q-card-media>
  <q-card-title>
    <img src="@/assets/InsafetyMap.png">
  </q-card-title>
  <q-card-main>
    <p>Insafety GmbH, Viaduktstrasse 95, CH-8005 Zürich</p>
    <p class="text-faded"><a href="mailto:welcome@insafety.ch">welcome@insafety.ch</a></p>
    <p class="text-faded">WTracking Version B.1.2010</p>
    <p class="text-faded">Quasar Version: {{$q.version}}</p>
  </q-card-main>
  
  <q-card-separator />
</q-card>   
  </div>
</template>

<script>
import { openURL } from 'quasar'

export default {
  name: 'SideDialog1',
  data () {
    return {
      positions: []
    }
  },
  methods: {
    getGps (){
      var options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      }

      if(navigator.geolocation){
        navigator.geolocation.getCurrentPosition(position => {
          this.positions.push(position.coords);
          console.log(position)
        }, error, options)
      }
       else {
         alert("Geolocation is not supported by this browser.")
      }
    }
  }
  
}

function error(err) {
  console.log(`ERROR(${err.code}): ${err.message}`);
}



</script>

<style>
</style>
